import {
  GamePlayData,
  Upgrades,
  UnlockRule,
  Multiplier,
  UpgradeCategories,
  UpgradeCategory,
  Upgrade,
  UpgradeEnum
} from '../types'

const UPGRADES: Upgrades = {
  bike: {
    key: 'bike',
    name: 'Bike',
    description: 'A faster way to get around.',
    cost: 30,
    effects: [],
    visibilityRules: [{ category: 'job', key: 'dishwasher', value: 10 }],
    category: 'game_progression'
  },
  first_surf_lesson: {
    key: 'first_surf_lesson',
    name: 'First Surf Lesson',
    description: 'What got you started.',
    cost: 80,
    effects: [],
    visibilityRules: [],
    category: 'game_progression'
  },
  first_aid_training: {
    key: 'first_aid_training',
    name: 'First Aid Training',
    description: 'Learn how to save a life.',
    cost: 200,
    effects: [],
    visibilityRules: [{ category: 'job', key: 'surfboard_rental_assistant', value: 1 }],
    category: 'game_progression'
  },
  online_surf_coaching: {
    key: 'online_surf_coaching',
    name: 'Online Surf Coaching',
    description: 'Learn how to surf from a pro.',
    cost: 100,
    effects: [],
    visibilityRules: [{ category: 'level', key: 'skill', value: 9 }],
    category: 'game_progression'
  },
  surfboard_shaping_brand: {
    key: 'surfboard_shaping_brand',
    name: 'Surfboard Shaping Brand',
    description: 'Establish your own surfboard shaping business and brand.',
    cost: 100000,
    effects: [],
    visibilityRules: [{ category: 'level', key: 'skill', value: 6 }],
    category: 'game_progression'
  },
  online_surf_platform: {
    key: 'online_surf_platform',
    name: 'Online Surf Platform',
    description: 'Create your own online surf education platform.',
    cost: 300000,
    effects: [],
    visibilityRules: [{ category: 'level', key: 'skill', value: 7 }],
    category: 'game_progression'
  },
  surf_clothing_brand: {
    key: 'surf_clothing_brand',
    name: 'Surf Clothing Brand',
    description: 'Launch your own surf apparel and lifestyle brand.',
    cost: 1000000,
    effects: [],
    visibilityRules: [{ category: 'level', key: 'skill', value: 8 }],
    category: 'game_progression'
  },
  surf_camp_franchise: {
    key: 'surf_camp_franchise',
    name: 'Surf Camp Franchise',
    description: 'Develop a network of premium surf camps around the world.',
    cost: 3000000,
    effects: [],
    visibilityRules: [{ category: 'level', key: 'skill', value: 9 }],
    category: 'game_progression'
  },
  wave_pool_tech: {
    key: 'wave_pool_tech',
    name: 'Wave Pool Tech',
    description: 'Acquire the licence to technology to build a wave pool.',
    cost: 10000000,
    effects: [],
    visibilityRules: [{ category: 'level', key: 'skill', value: 10 }],
    category: 'game_progression'
  },
  board_70oldmal: {
    key: 'board_70oldmal',
    name: "Old 70's Mal",
    description: 'A classic board with unique characteristics.',
    cost: 0,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'paddling', value: 0.7 },
      { type: 'permanent', effectCategory: 'skill', key: 'popup', value: 0.7 }
    ],
    visibilityRules: [],
    category: 'surfboards'
  },
  board_8ft_softtop: {
    key: 'board_8ft_softtop',
    name: 'Foamie',
    description: 'Great for beginners and whitewater riding.',
    cost: 100,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'paddling', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'popup', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'whitewater_riding', value: 2.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'bottom_turn_front', value: 0.8 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 0.8 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 1 }],
    category: 'surfboards'
  },
  board_minimal: {
    key: 'board_minimal',
    name: 'Mini-Mal',
    description: 'A versatile board for various conditions.',
    cost: 200,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'paddling', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'popup', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'green_wave_riding', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'bottom_turn_front', value: 0.9 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 0.9 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 2 }],
    category: 'surfboards'
  },
  board_longboard: {
    key: 'board_longboard',
    name: 'Longboard',
    description: 'Ideal for smooth rides and popup.',
    cost: 300,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'paddling', value: 1.7 },
      { type: 'permanent', effectCategory: 'skill', key: 'popup', value: 1.4 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 0.8 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_back', value: 0.8 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 3 }],
    category: 'surfboards'
  },
  board_shortboard_allrounder: {
    key: 'board_shortboard_allrounder',
    name: 'Shortboard (All-Rounder)',
    description: 'Perfect for versatile surfing styles.',
    cost: 400,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'bottom_turn_front', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'bottom_turn_back', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_back', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'speed_generation', value: 1.2 },
      { type: 'permanent', effectCategory: 'skill', key: 'paddling', value: 1.2 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 4 }],
    category: 'surfboards'
  },
  board_shortboard_groveler: {
    key: 'board_shortboard_groveler',
    name: 'Shortboard (Groveler)',
    description: 'Designed for smaller mushy waves.',
    cost: 500,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'speed_generation', value: 1.2 },
      { type: 'permanent', effectCategory: 'skill', key: 'popup', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'paddling', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'cutback_front', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'cutback_back', value: 1.5 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 5 }],
    category: 'surfboards'
  },
  board_barrel: {
    key: 'board_barrel',
    name: 'Barrel Board',
    description: 'Optimized for barrel riding.',
    cost: 600,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'barrel', value: 1.8 },
      { type: 'permanent', effectCategory: 'skill', key: 'speed_generation', value: 1.2 },
      { type: 'permanent', effectCategory: 'skill', key: 'speed_control', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'paddling', value: 0.6 },
      { type: 'permanent', effectCategory: 'skill', key: 'popup', value: 0.6 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 6 }],
    category: 'surfboards'
  },
  board_midlength: {
    key: 'board_midlength',
    name: 'Midlength Board',
    description: 'popup for all-around performance.',
    cost: 450,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'popup', value: 1.2 },
      { type: 'permanent', effectCategory: 'skill', key: 'speed_generation', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'cutback_front', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'cutback_back', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'speed_control', value: 0.8 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 4 }],
    category: 'surfboards'
  },
  board_custom_shaped: {
    key: 'board_custom_shaped',
    name: 'Custom Shaped Board',
    description: 'Tailored for all-round skills.',
    cost: 700,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 1.7 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_back', value: 1.7 },
      { type: 'permanent', effectCategory: 'skill', key: 'bottom_turn_front', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'bottom_turn_back', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'cutback_front', value: 1.5 },
      { type: 'permanent', effectCategory: 'skill', key: 'cutback_back', value: 1.5 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 5 }],
    category: 'surfboards'
  },
  board_shortboard_aerial: {
    key: 'board_shortboard_aerial',
    name: 'Shortboard (Aerial Focus)',
    description: 'Specialized for aerial maneuvers.',
    cost: 800,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'aerial', value: 1.8 },
      { type: 'permanent', effectCategory: 'skill', key: 'air_reverse', value: 1.8 },
      { type: 'permanent', effectCategory: 'skill', key: 'speed_generation', value: 1.3 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 7 }],
    category: 'surfboards'
  },
  // Coaching Category
  skilled_friend: {
    key: 'skilled_friend',
    name: 'Skilled Friend',
    description: 'Gain skills faster with a friend.',
    cost: 50,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'popup', value: 1.1 },
      { type: 'permanent', effectCategory: 'skill', key: 'wave_reading', value: 1.05 }
    ],
    visibilityRules: [
      { category: 'level', key: 'skill', value: 2 },
      { category: 'location', key: 'france', value: 1 }
    ],
    category: 'coaching'
  },
  local_coach: {
    key: 'local_coach',
    name: 'Local Coach',
    description: 'Improve paddling and wave reading.',
    cost: 100,
    hourlyFee: 0.3,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'paddling', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'popup', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'wave_reading', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'forecasting_and_observing', value: 1.3 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 4 }],
    category: 'coaching'
  },
  video_coach: {
    key: 'video_coach',
    name: 'Video Coach',
    description: 'Learn advanced turns through video coaching.',
    cost: 550,
    hourlyFee: 1,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'bottom_turn_front', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 1.3 }
    ],
    visibilityRules: [
      { category: 'level', key: 'skill', value: 5 },
      { category: 'purchase', key: 'prepaid_phone_internet', value: 1 }
    ],
    category: 'coaching'
  },
  renowned_coach: {
    key: 'renowned_coach',
    name: 'Renowned Coach',
    description: 'Boosts to barrel riding and aerials.',
    cost: 2000,
    hourlyFee: 3,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'cutback_front', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'cutback_back', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_back', value: 1.3 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 6 }],
    category: 'coaching'
  },
  pro_surfer_coach: {
    key: 'pro_surfer_coach',
    name: 'Pro Surfer Coach',
    description: 'Maximize all skills with a pro coach.',
    cost: 30000,
    hourlyFee: 10,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'speed_control', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'speed_generation', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'floater', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'aerial', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'air_reverse', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'barrel', value: 1.3 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 8 }],
    category: 'coaching'
  },

  // Digital Tools Category
  prepaid_phone_internet: {
    key: 'prepaid_phone_internet',
    name: 'Prepaid Phone with Internet',
    description: 'Access to wave reading tutorials.',
    cost: 100,
    effects: [{ type: 'permanent', effectCategory: 'skill', key: 'wave_reading', value: 1.05 }],
    visibilityRules: [{ category: 'level', key: 'skill', value: 2 }],
    category: 'digital_tools'
  },
  surf_forecasting_app: {
    key: 'surf_forecasting_app',
    name: 'Surf Forecasting App',
    description: 'Improve forecasting and observing skills.',
    cost: 0,
    hourlyFee: 1,
    effects: [{ type: 'permanent', effectCategory: 'skill', key: 'forecasting_and_observing', value: 1.4 }],
    visibilityRules: [{ category: 'level', key: 'skill', value: 2 }],
    category: 'digital_tools'
  },
  breathwork_app: {
    key: 'breathwork_app',
    name: 'Paid App: Breathwork for Surfers',
    description: 'Enhance fitness through breathwork.',
    cost: 200,
    effects: [{ type: 'permanent', effectCategory: 'skill', key: 'fitness', value: 1.15 }],
    visibilityRules: [{ category: 'level', key: 'skill', value: 4 }],
    category: 'digital_tools'
  },
  mobility_app: {
    key: 'mobility_app',
    name: 'Paid App: Mobility for Surfers',
    description: 'Improve turns and speed control.',
    cost: 200,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'bottom_turn_front', value: 1.1 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 1.1 },
      { type: 'permanent', effectCategory: 'skill', key: 'speed_control', value: 1.05 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 4 }],
    category: 'digital_tools'
  },
  pro_surf_coaches_series: {
    key: 'pro_surf_coaches_series',
    name: 'Subscription: Pro Surf Coaching Video',
    description: 'Learn from top turns and aerials.',
    cost: 0,
    hourlyFee: 1,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 1.15 },
      { type: 'permanent', effectCategory: 'skill', key: 'aerial', value: 1.1 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 6 }],
    category: 'digital_tools'
  },
  advanced_forecasting_app: {
    key: 'advanced_forecasting_app',
    name: 'Advanced Forecasting App',
    description: 'Advanced forecasting and wave reading.',
    cost: 350,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'forecasting_and_observing', value: 1.25 },
      { type: 'permanent', effectCategory: 'skill', key: 'wave_reading', value: 1.1 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 7 }],
    category: 'digital_tools'
  },
  // Fitness & Gyms Category
  home_workout_gear: {
    key: 'home_workout_gear',
    name: 'Home Workout Gear',
    description: 'Boost fitness and speed generation.',
    cost: 200,
    effects: [{ type: 'permanent', effectCategory: 'skill', key: 'fitness', value: 1.3 }],
    visibilityRules: [],
    category: 'fitness_gyms'
  },
  small_local_gym: {
    key: 'small_local_gym',
    name: 'Small Local Gym',
    description: 'Improve fitness.',
    cost: 0,
    hourlyFee: 0.2,
    effects: [{ type: 'permanent', effectCategory: 'skill', key: 'fitness', value: 1.4 }],
    visibilityRules: [{ category: 'level', key: 'skill', value: 2 }],
    category: 'fitness_gyms'
  },
  big_gym_membership: {
    key: 'big_gym_membership',
    name: 'Big Gym Membership',
    description: 'Enhance fitness and paddling.',
    cost: 0,
    hourlyFee: 2,
    effects: [{ type: 'equipped', effectCategory: 'skill', key: 'fitness', value: 1.6 }],
    visibilityRules: [{ category: 'level', key: 'skill', value: 3 }],
    category: 'fitness_gyms'
  },
  big_gym_with_trainer: {
    key: 'big_gym_with_trainer',
    name: 'Big Gym with Trainer',
    description: 'Maximize fitness and turns.',
    cost: 0,
    hourlyFee: 4,
    effects: [
      { type: 'equipped', effectCategory: 'skill', key: 'fitness', value: 1.6 },
      { type: 'equipped', effectCategory: 'skill', key: 'paddling', value: 1.2 },
      { type: 'equipped', effectCategory: 'skill', key: 'popup', value: 1.2 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 4 }],
    category: 'fitness_gyms'
  },
  surf_specific_mobility_class: {
    key: 'surf_specific_mobility_class',
    name: 'Surf-Specific Mobility Class',
    description: 'Improve popup and top turns.',
    cost: 100,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'popup', value: 1.1 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 1.1 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 3 }],
    category: 'fitness_gyms'
  },
  advanced_gym_with_trainer: {
    key: 'advanced_gym_with_trainer',
    name: 'Advanced Gym with Surf Trainer',
    description: 'Boost fitness, paddling, and turns.',
    cost: 1000,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'fitness', value: 1.3 },
      { type: 'permanent', effectCategory: 'skill', key: 'paddling', value: 1.2 },
      { type: 'permanent', effectCategory: 'skill', key: 'bottom_turn_front', value: 1.15 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 1.15 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 7 }],
    category: 'fitness_gyms'
  },

  // Surf Gear & Accessories Category
  basic_wetsuit: {
    key: 'basic_wetsuit',
    name: 'Basic Wetsuit',
    description: 'Increase stamina.',
    cost: 75,
    effects: [{ type: 'permanent', effectCategory: 'skill', key: 'fitness', value: 1.05 }],
    visibilityRules: [{ category: 'location', key: 'mediterranean', value: 1 }],
    category: 'surf_gear_accessories'
  },
  performance_wetsuit: {
    key: 'performance_wetsuit',
    name: 'Performance Wetsuit',
    description: 'Boost stamina and paddling.',
    cost: 250,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'fitness', value: 1.15 },
      { type: 'permanent', effectCategory: 'skill', key: 'paddling', value: 1.1 }
    ],
    visibilityRules: [{ category: 'location', key: 'france', value: 1 }],
    category: 'surf_gear_accessories'
  },
  advanced_wetsuit: {
    key: 'advanced_wetsuit',
    name: 'Advanced Wetsuit',
    description: 'Maximize stamina and paddling.',
    cost: 500,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'fitness', value: 1.2 },
      { type: 'permanent', effectCategory: 'skill', key: 'paddling', value: 1.15 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 5 }],
    category: 'surf_gear_accessories'
  },
  surf_watch_beginner: {
    key: 'surf_watch_beginner',
    name: 'Surf Watch (Beginner)',
    description: 'Improve wave reading.',
    cost: 150,
    effects: [{ type: 'permanent', effectCategory: 'skill', key: 'wave_reading', value: 1.05 }],
    visibilityRules: [{ category: 'location', key: 'france', value: 1 }],
    category: 'surf_gear_accessories'
  },
  advanced_surf_watch: {
    key: 'advanced_surf_watch',
    name: 'Surf Watch with Tides',
    description: 'Enhance wave reading and forecasting.',
    cost: 350,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'wave_reading', value: 1.15 },
      { type: 'permanent', effectCategory: 'skill', key: 'forecasting_and_observing', value: 1.1 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 5 }],
    category: 'surf_gear_accessories'
  },
  custom_fins: {
    key: 'custom_fins',
    name: 'Custom Fins',
    description: 'Boost turns and speed generation.',
    cost: 200,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'bottom_turn_front', value: 1.1 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 1.1 },
      { type: 'permanent', effectCategory: 'skill', key: 'speed_generation', value: 1.05 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 4 }],
    category: 'surf_gear_accessories'
  },
  performance_fins: {
    key: 'performance_fins',
    name: 'Performance Fins',
    description: 'Maximize turns and speed generation.',
    cost: 400,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'bottom_turn_front', value: 1.15 },
      { type: 'permanent', effectCategory: 'skill', key: 'top_turn_front', value: 1.15 },
      { type: 'permanent', effectCategory: 'skill', key: 'speed_generation', value: 1.1 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 6 }],
    category: 'surf_gear_accessories'
  },
  wave_helmet: {
    key: 'wave_helmet',
    name: 'Wave Helmet',
    description: 'Reduce injury risk, boost confidence and barrel riding.',
    cost: 300,
    effects: [
      { type: 'permanent', effectCategory: 'skill', key: 'fitness', value: 1.1 },
      { type: 'permanent', effectCategory: 'skill', key: 'barrel', value: 1.1 }
    ],
    visibilityRules: [{ category: 'level', key: 'skill', value: 6 }],
    category: 'surf_gear_accessories'
  },
  // Housing Upgrades
  old_car: {
    key: 'old_car',
    name: 'Old Car',
    description: 'Living in your car. Not comfortable but very cheap.',
    category: 'housing',
    cost: 0,
    hourlyFee: 0,
    visibilityRules: [],
    effects: [{ type: 'equipped', effectCategory: 'currency', key: 'energy', value: 1.0 }]
  },
  surf_hostel_bunk: {
    key: 'surf_hostel_bunk',
    name: 'Surf Hostel Bunk Bed',
    description: 'Share a room with fellow surfers. Great for networking, not so much for rest.',
    category: 'housing',
    cost: 140,
    hourlyFee: 1,
    visibilityRules: [{ category: 'purchase', key: 'old_car', value: 1 }],
    effects: [{ type: 'equipped', effectCategory: 'currency', key: 'energy', value: 1.2 }]
  },
  surf_hostel_private: {
    key: 'surf_hostel_private',
    name: 'Surf Hostel Private Room',
    description: 'Living with other surfers, great for learning about local spots.',
    category: 'housing',
    cost: 280,
    hourlyFee: 2,
    visibilityRules: [{ category: 'purchase', key: 'surf_hostel_bunk', value: 1 }],
    effects: [
      { type: 'equipped', effectCategory: 'currency', key: 'energy', value: 1.5 },
      { type: 'equipped', effectCategory: 'skill', key: 'forecasting_and_observing', value: 1.1 }
    ]
  },
  shared_apartment: {
    key: 'shared_apartment',
    name: 'Shared Apartment',
    description: 'Sharing with other surfers. Good balance of comfort and price.',
    category: 'housing',
    cost: 700,
    hourlyFee: 4,
    visibilityRules: [{ category: 'purchase', key: 'surf_hostel_private', value: 1 }],
    effects: [
      { type: 'equipped', effectCategory: 'currency', key: 'energy', value: 2.0 },
      { type: 'equipped', effectCategory: 'skill', key: 'forecasting_and_observing', value: 1.25 }
    ]
  },
  beachfront_studio: {
    key: 'beachfront_studio',
    name: 'Beachfront Studio',
    description: 'Your own place with ocean views. Perfect for monitoring conditions.',
    category: 'housing',
    cost: 2800,
    hourlyFee: 18,
    visibilityRules: [{ category: 'purchase', key: 'shared_apartment', value: 1 }],
    effects: [
      { type: 'equipped', effectCategory: 'currency', key: 'energy', value: 2.6 },
      { type: 'equipped', effectCategory: 'skill', key: 'forecasting_and_observing', value: 1.45 },
      { type: 'equipped', effectCategory: 'skill', key: 'wave_reading', value: 1.2 }
    ]
  },
  surf_villa: {
    key: 'surf_villa',
    name: 'Surf Villa',
    description: 'Luxurious villa with private access to surf spots.',
    category: 'housing',
    cost: 6300,
    hourlyFee: 40,
    visibilityRules: [{ category: 'purchase', key: 'beachfront_studio', value: 1 }],
    effects: [
      { type: 'equipped', effectCategory: 'currency', key: 'energy', value: 3.3 },
      { type: 'equipped', effectCategory: 'skill', key: 'forecasting_and_observing', value: 1.7 },
      { type: 'equipped', effectCategory: 'skill', key: 'wave_reading', value: 1.5 }
    ]
  },
  beach_house: {
    key: 'beach_house',
    name: 'Beach House',
    description: 'Your own house steps from the ocean.',
    category: 'housing',
    cost: 9800,
    hourlyFee: 60,
    visibilityRules: [{ category: 'purchase', key: 'surf_villa', value: 1 }],
    effects: [
      { type: 'equipped', effectCategory: 'currency', key: 'energy', value: 4.2 },
      { type: 'equipped', effectCategory: 'skill', key: 'forecasting_and_observing', value: 2.0 },
      { type: 'equipped', effectCategory: 'skill', key: 'wave_reading', value: 1.9 }
    ]
  },
  ocean_mansion: {
    key: 'ocean_mansion',
    name: 'Ocean View Mansion',
    description: 'Luxury mansion with full service and helicopter pad for accessing remote spots.',
    category: 'housing',
    cost: 14000,
    hourlyFee: 85,
    visibilityRules: [{ category: 'purchase', key: 'beach_house', value: 1 }],
    effects: [
      { type: 'equipped', effectCategory: 'currency', key: 'energy', value: 5.0 },
      { type: 'equipped', effectCategory: 'skill', key: 'forecasting_and_observing', value: 2.5 },
      { type: 'equipped', effectCategory: 'skill', key: 'wave_reading', value: 2.5 }
    ]
  }
}

const UPGRADE_CATEGORIES: UpgradeCategories = {
  game_progression: {
    key: 'game_progression',
    name: 'Quest',
    upgrades: [
      'bike',
      'first_surf_lesson',
      'first_aid_training',
      'online_surf_coaching',
      'online_surf_platform',
      'surfboard_shaping_brand',
      'surf_clothing_brand',
      'surf_camp_franchise',
      'wave_pool_tech'
    ]
  },
  surfboards: {
    key: 'surfboards',
    name: 'Surfboards',
    upgrades: [
      'board_70oldmal',
      'board_8ft_softtop',
      'board_minimal',
      'board_longboard',
      'board_shortboard_allrounder',
      'board_shortboard_groveler',
      'board_barrel',
      'board_midlength',
      'board_custom_shaped',
      'board_shortboard_aerial'
    ]
  },
  coaching: {
    key: 'coaching',
    name: 'Coaching',
    upgrades: ['skilled_friend', 'local_coach', 'video_coach', 'renowned_coach', 'pro_surfer_coach']
  },
  digital_tools: {
    key: 'digital_tools',
    name: 'Apps',
    upgrades: [
      'prepaid_phone_internet',
      'surf_forecasting_app',
      'breathwork_app',
      'mobility_app',
      'pro_surf_coaches_series',
      'advanced_forecasting_app'
    ]
  },
  fitness_gyms: {
    key: 'fitness_gyms',
    name: 'Gym',
    upgrades: [
      'home_workout_gear',
      'small_local_gym',
      'big_gym_membership',
      'big_gym_with_trainer',
      'surf_specific_mobility_class',
      'advanced_gym_with_trainer'
    ]
  },
  surf_gear_accessories: {
    key: 'surf_gear_accessories',
    name: 'Gear',
    upgrades: [
      'basic_wetsuit',
      'performance_wetsuit',
      'advanced_wetsuit',
      'surf_watch_beginner',
      'advanced_surf_watch',
      'custom_fins',
      'performance_fins',
      'wave_helmet'
    ]
  },
  housing: {
    key: 'housing',
    name: 'Housing',
    upgrades: [
      'old_car',
      'surf_hostel_bunk',
      'surf_hostel_private',
      'shared_apartment',
      'beachfront_studio',
      'surf_villa',
      'beach_house',
      'ocean_mansion'
    ]
  }
}

export { UPGRADES, UPGRADE_CATEGORIES }
